module.exports = __webpack_public_path__ + "img/16-3.ea5820b5.png";